import React from "react";

function MaintenanceMode() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <div className="flex justify-center mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-yellow-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Maintenance Mode
        </h1>
        <p className="text-lg text-gray-600 mb-6">
          We are currently undergoing maintenance. We expect to be back in 6
          hours. Thank you for your patience and sorry for the inconvenience.
        </p>
      </div>
    </div>
  );
}

export default MaintenanceMode;
